import { useState } from "react";
import HexMap from "../../../../../components/HexMap";
import { getLabel } from "../../../../../hooks/use-labels";
import HexButton from "../../../../../ui-kit/HexButtons";

const MapAddress = ({ onSave, addressText, latitude, longitude }) => {
  const [mapAddress, setMapAddress] = useState({
    latitude: latitude || 0,
    longitude: longitude || 0,
  });

  
  const onMapAddressChange = (address) => {
    setMapAddress(address);
  };

  return (
    <div>
      <HexMap
        mapProps={{ ...mapAddress, addressText }}
        onSave={onMapAddressChange}
      />

      <div className="business__btn choose-location">
        <HexButton
          label={getLabel("chooseLocation")}
          disable={!mapAddress || (mapAddress && !mapAddress.latitude)}
          type="primary"
          size="lg"
          onClick={() => onSave(mapAddress)}
        />
      </div>
    </div>
  );
};

export default MapAddress;
